import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { CheckCircleOutline } from "@material-ui/icons";
import Button from "./Button";
import styles from "../styles/ModalSucesso.module.scss";

/**
 * Modal de sucesso com animacao de abertura/fechamento.
 *
 * @param {boolean} aberto - Controla a visibilidade do modal
 * @param {Function} onFechar - Callback para fechar o modal
 * @param {string} titulo - Titulo do modal
 * @param {string} descricao - Descricao do modal
 * @param {string} texto_botao - Texto do botao (default: "Fechar")
 */
export default function ModalSucesso({
  aberto,
  onFechar,
  titulo,
  descricao,
  texto_botao = "Fechar",
}) {
  const [visivel, setVisivel] = useState(aberto);
  const [saindo, setSaindo] = useState(false);

  useEffect(() => {
    if (aberto) {
      setVisivel(true);
      setSaindo(false);
    } else if (visivel) {
      setSaindo(true);

      const timer = setTimeout(() => {
        setVisivel(false);
        setSaindo(false);
      }, 220);

      return () => clearTimeout(timer);
    }
  }, [aberto]);

  if (!visivel) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={`${styles.overlay} ${saindo ? styles.saindo : ""}`}>
      <div className={`${styles.modal} ${saindo ? styles.modalSaindo : ""}`}>
        <div className={styles.modalBody}>
          <div className={styles.icone}>
            <CheckCircleOutline style={{ fontSize: 32 }} />
          </div>

          <p className={styles.titulo}>{titulo}</p>
          <p className={styles.descricao}>{descricao}</p>
        </div>

        <div className={styles.modalFooter}>
          <Button
            type="button"
            variant="default"
            outlined
            size="md"
            onClick={onFechar}
          >
            {texto_botao}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}
